
import React from 'react';

interface ScreenshotCaptionProps {
  title: string;
  description: string;
  isMobile?: boolean;
}

const ScreenshotCaption: React.FC<ScreenshotCaptionProps> = ({ 
  title, 
  description, 
  isMobile = false 
}) => {
  return (
    <div className="p-4 md:p-6 text-center">
      <h3 className={`font-semibold font-playfair text-charcoal mb-1 md:mb-2 ${
        isMobile ? 'text-base' : 'text-lg'
      }`}>
        {title}
      </h3>
      <p className="text-sm text-muted-foreground font-inter">
        {description}
      </p>
    </div>
  );
};

export default ScreenshotCaption;
